export default __webpack_public_path__ + "static/media/apdated-logo-header.df2498db.svg";